const layoutTypes = {
    CREATE_LAYOUT_ACTION: "CREATE_LAYOUT_ACTION",
    GET_LIST_LAYOUT_ACTION: "GET_LIST_LAYOUT_ACTION",
    GET_LIST_ALL_LAYOUT_ACTION: "GET_LIST_ALL_LAYOUT_ACTION",
    GET_DETAIL_LAYOUT_ACTION: "GET_DETAIL_LAYOUT_ACTION",
    UPDATE_LAYOUT_ACTION: "UPDATE_LAYOUT_ACTION",
    CREATE_LAYOUT_SUCCESS: "CREATE_LAYOUT_SUCCESS",
    GET_LIST_LAYOUT_SUCCESS: "GET_LIST_LAYOUT_SUCCESS",
    GET_LIST_ALL_LAYOUT_SUCCESS: "GET_LIST_ALL_LAYOUT_SUCCESS",
    GET_DETAIL_LAYOUT_SUCCESS: "GET_DETAIL_LAYOUT_SUCCESS",
    UPDATE_LAYOUT_SUCCESS: "UPDATE_LAYOUT_SUCCESS",
    CREATE_LAYOUT_FAILED: "CREATE_LAYOUT_FAILED",
    GET_LIST_ALL_LAYOUT_FAILED: "GET_LIST_ALL_LAYOUT_FAILED",
    GET_LIST_LAYOUT_FAILED: "GET_LIST_LAYOUT_FAILED",
    GET_DETAIL_LAYOUT_FAILED: "GET_DETAIL_LAYOUT_FAILED",
    UPDATE_LAYOUT_FAILED: "UPDATE_LAYOUT_FAILED",
    CLEAR_LAYOUT_ACTION: "CLEAR_LAYOUT_ACTION"
}

export default layoutTypes;